import { concat } from '@ember/helper';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert, didUpdate } from '@ember/render-modifiers';
import { type Registry as Services, service } from '@ember/service';
import { styleEntry } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, not, or } from 'ember-truth-helpers';
import MyAndMarketOtbIllustration from 'lumen/assets/images/upsell/rates-pace-my-and-market-otb.svg?raw';
import MyOtbIllustration from 'lumen/assets/images/upsell/rates-pace-my-otb.svg?raw';
import GeneralDayDetailChartsChartBookingCurve from 'lumen/components/general/day-detail/charts/chart-booking-curve';
import GeneralDayDetailTabsTabDayDetailBase from 'lumen/components/general/day-detail/tabs/tab-day-detail-base';
import GeneralEmptyStateOccupancy from 'lumen/components/general/empty-state-occupancy';
import GeneralEmptyStateOtbBanner from 'lumen/components/general/empty-state-otb-banner';
import GeneralModalFilterBar from 'lumen/components/general/modal-filter-bar';
import hasFeature from 'lumen/helpers/has-feature';
import { getTranslationKeysForBanner } from 'lumen/utils/components/general/empty-state-otb-banner';
import {
  OTB_SS_ENTRY_POINTS,
  OTB_SS_VIA_QP_VALUES,
} from 'lumen/utils/constants/otb-selfservice-constants';

// @ts-expect-error: Incorrect type
export default class GeneralDayDetailTabsTabBookingCurve extends GeneralDayDetailTabsTabDayDetailBase {
  @service declare access: Services['access'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get emptyStateOccupancyImage() {
    if (this.access.hasFeature('otb.market_benchmark_eligible')) {
      return MyAndMarketOtbIllustration;
    }

    return MyOtbIllustration;
  }

  @computed('intl', 'model.periods.[]', 'sortedPeriods.length')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasNoDataForSelection() {
    let message = { hasMessage: false };
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const noResult = !this.sortedPeriods.length;

    if (noResult) {
      // @ts-expect-error: Incorrect type
      message = { hasMessage: true, message: this.intl.t('otb.missing_data') };
    }
    return message;
  }

  <template>
    {{#if
      (or
        (hasFeature "pms.otb.view")
        (and
          this.access.hasShortTermRentalAccess
          (not this.access.hasShortTermRentalOnlyStrTab)
        )
      )
    }}
      {{#if (hasFeature "otb.empty_placeholder")}}
        <div
          {{didInsert this.setBannerHeight}}
          {{didUpdate this.setBannerHeight @params.height @isLoading}}
        >
          <GeneralEmptyStateOtbBanner
            @bannerPosition="top"
            @otbSelfServiceEntryPoint={{OTB_SS_ENTRY_POINTS.RATES_EVOLUTION_CHART}}
            @otbSelfServiceEntryProduct={{OTB_SS_VIA_QP_VALUES.RATE_INSIGHT}}
          />
        </div>
      {{/if}}
      <GeneralModalFilterBar class="flex justify-between">
        <div class="modal-filter-bar__filter-text truncate">
          {{#if this.params.paceTabFilterMessage}}
            {{this.params.paceTabFilterMessage}}
          {{else}}
            {{t "pace.OTB_rooms_sold"}}
          {{/if}}
        </div>
      </GeneralModalFilterBar>
      {{#if @isLoading}}
        <div class="bc-curve">
          <GeneralDayDetailChartsChartBookingCurve
            @containerHeight={{this.correctedHeight}}
            {{! @glint-expect-error: Incorrect type }}
            @date={{this.params.date}}
            @isLoading={{true}}
            @model={{this.model}}
            @sortedPeriods={{this.sortedPeriods}}
          />
        </div>
      {{else}}
        <div class="bc-curve">
          <GeneralDayDetailChartsChartBookingCurve
            @containerHeight={{this.correctedHeight}}
            @dayMoment={{@dayMoment}}
            {{! @glint-expect-error: Incorrect type }}
            @isLoading={{@isLoading}}
            @message={{this.hasNoDataForSelection}}
            @model={{this.model}}
            @rentalData={{this.model.rental}}
            @sortedPeriods={{this.sortedPeriods}}
          />
        </div>
      {{/if}}
    {{else}}
      <div
        class="flex items-center justify-center"
        style={{styleEntry "height" (concat this.correctedHeight "px")}}
      >
        {{#let
          (getTranslationKeysForBanner
            OTB_SS_ENTRY_POINTS.RATES_PACE_CHART
            (hasFeature "otb.market_benchmark_eligible")
          )
          as |translationKeys|
        }}
          <GeneralEmptyStateOccupancy
            @imgHtml={{this.emptyStateOccupancyImage}}
            @otbSelfServiceEntryPoint={{OTB_SS_ENTRY_POINTS.RATES_PACE_CHART}}
            @otbSelfServiceEntryProduct={{OTB_SS_VIA_QP_VALUES.RATE_INSIGHT}}
            @stateDescription={{t translationKeys.message}}
            {{! @glint-expect-error: Incorrect type }}
            @stateTitle={{t translationKeys.title}}
          />
        {{/let}}
      </div>
    {{/if}}
  </template>
}
